
import { api } from "../../config/apiConfig";
import { FIND_IMAGE_FAILURE, FIND_IMAGE_REQUEST, FIND_IMAGE_SUCCESS, FIND_PRODUCT_BY_CATEGORY_FAILURE, FIND_PRODUCT_BY_CATEGORY_REQUEST, FIND_PRODUCT_BY_CATEGORY_SUCCESS, FIND_PRODUCT_BY_ID_FAILURE, FIND_PRODUCT_BY_ID_REQUEST, FIND_PRODUCT_BY_ID_SUCCESS } from "./ActionType";

export const findProductsById = (reqData) => async (dispatch) => {
    dispatch({ type: FIND_PRODUCT_BY_ID_REQUEST })
    try {
        const { data } = await api.get(`products/id/${reqData.productId}`)
        
        dispatch({ type: FIND_PRODUCT_BY_ID_SUCCESS, payload: data })
        return data;
    } catch (error) {
        dispatch({ type: FIND_PRODUCT_BY_ID_FAILURE, payload: error.message })
    }
}

export const findImageProduct = (reqData) => async (dispatch) => {
    dispatch({ type: FIND_IMAGE_REQUEST })
    if (reqData.color === null )
    reqData.color = ' ';
    try {
        const { data } = await api.get(`products/color/${reqData.productId}/${reqData.color}`)
        dispatch({ type: FIND_IMAGE_SUCCESS, payload: data })
        return data;

    } catch (error) {
        dispatch({ type: FIND_IMAGE_FAILURE, payload: error.message })
    }

}

export const findProductsByCategory = (reqData) => async (dispatch) => {
    
    dispatch({ type: FIND_PRODUCT_BY_CATEGORY_REQUEST })
    // if (!reqData.sizes || reqData.sizes?.length === 0)
    //     reqData.sizes = ' ';
    // if (!reqData.colors || reqData.colors?.length === 0)
    //     reqData.colors = ' ';
    if (!reqData.pageNumber || reqData.pageNumber?.length === 0)
        reqData.pageNumber = 1;
    try {
        
        const { data } = await api.get(`category/${reqData.categoryId}/${reqData.pageNumber}`)
        
        dispatch({ type: FIND_PRODUCT_BY_CATEGORY_SUCCESS, payload: data })
        
        return data;
    } catch (error) {
        dispatch({ type: FIND_PRODUCT_BY_CATEGORY_FAILURE, payload: error.message })
    }
}



export const findProductsByKeyword = (reqData) => async () => {
    try {
        const { data } = await api.get(`/product/search/${reqData}`)
        return data;
    } catch (error) {
        return "";
    }

}